// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseURL: string;
};

export type TranslationEntity = {
  languageCode: string;
  value: string;
  announcementTitleId: number | null;
  announcementMessageId: number | null;
  cryptorTitleId: number | null;
  cryptorLinkWithThePlaceId: number | null;
  cryptorQuoteId: number | null;
  cryptorDescriptionId: number | null;
  cryptorDifficultyTranslationId: number | null;
  faqId: number | null;
  faqAnswerId: number | null;
  faqQuestionId: number | null;
  messageTextId: number | null;
  propositionTextId: number | null;
  questionTextId: number | null;
  answerDetailsDescriptionId: number | null;
  levelTranslationId: number | null;
  artefactTextPopUpId: number | null;
  artefactTitlePopUpId: number | null;
  hintDescriptionId: string | null;
  questionId: string | null;
  propositionId: string | null;
};

export type UpdateTranslationDto = {
  value?: string;
};

export type GenerateMissingKeysEntity = {
  total: number;
};

export type ImageEntity = {
  id: number;
  url: string;
  thumbnailUrl: string | null;
};

export type AvatarEntity = {
  id: number;
  image: ImageEntity;
};

export type UpdateMyAvatarDto = {
  avatarId: number;
};

export type CreateImageDto = {
  url: string;
};

export type CreateAvatarDto = {
  image: CreateImageDto;
};

export type LeaderboardUserEntity = {
  id: number;
  pseudo: string | null;
  avatar: AvatarEntity;
  /**
   * Total score across all cryptors the user has played.
   */
  score: number;
  /**
   * 1-based rank in the leaderboard.
   */
  rank: number;
};

export type LeaderboardEntity = {
  /**
   * Total number of players eligible for the leaderboard.
   */
  playerCount: number;
  users: Array<LeaderboardUserEntity>;
};

export const Role = {
  ADMIN: "ADMIN",
  USER: "USER",
  CLIENT: "CLIENT",
  REDACTEUR: "REDACTEUR",
  ANALYSTE: "ANALYSTE",
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const UserTitle = {
  AGENT: "AGENT",
  AGENTE: "AGENTE",
  INDETERMINE: "INDETERMINE",
} as const;

export type UserTitle = (typeof UserTitle)[keyof typeof UserTitle];

export const PlayMode = {
  SOLO: "SOLO",
  FRIENDS: "FRIENDS",
  FAMILY: "FAMILY",
} as const;

export type PlayMode = (typeof PlayMode)[keyof typeof PlayMode];

export const AcquisitionSource = {
  SOCIAL_MEDIA: "SOCIAL_MEDIA",
  WORD_OF_MOUTH: "WORD_OF_MOUTH",
  TOURISM_OFFICE: "TOURISM_OFFICE",
  EVENT: "EVENT",
  OTHER: "OTHER",
} as const;

export type AcquisitionSource = (typeof AcquisitionSource)[keyof typeof AcquisitionSource];

export type CryptorDraftAccessEntity = {
  id: number;
};

export type UserResponseEntity = {
  role: Role;
  title: UserTitle | null;
  playMode: PlayMode | null;
  acquisitionSource: AcquisitionSource | null;
  id: number;
  pseudo: string | null;
  email: string | null;
  emailConfirmed: boolean;
  avatarId: number;
  avatar: AvatarEntity;
  isNewsletterAccepted: boolean;
  isTesterAccount: boolean;
  logoUrl: string | null;
  birthDay: number | null;
  birthMonth: number | null;
  birthYear: number | null;
  country: string | null;
  department: string | null;
  /**
   * BCP-47 language the user picked in the app (e.g. 'fr', 'en').
   */
  language: string | null;
  cryptorsDraftAccess: Array<CryptorDraftAccessEntity>;
  createdAt: string;
  /**
   * Total score across all cryptors the user has played.
   */
  score: number;
  /**
   * 1-based rank in the global player ranking.
   */
  rank: number;
};

export type UpdateMeDto = {
  title?: UserTitle | null;
  playMode?: PlayMode | null;
  acquisitionSource?: AcquisitionSource | null;
  pseudo?: string | null;
  avatarId?: number;
  email?: string | null;
  isNewsletterAccepted?: boolean;
  birthDay?: number | null;
  birthMonth?: number | null;
  birthYear?: number | null;
  country?: string | null;
  department?: string | null;
  language?: string | null;
};

export type UpdateUserDto = {
  role?: Role;
  pseudo?: string | null;
  avatarId?: number;
  email?: string | null;
  emailConfirmed?: boolean;
  cryptorsDraftAccess?: Array<number>;
  isTesterAccount?: boolean;
  logoUrl?: string | null;
};

export type AdminCreateUserDto = {
  role: Role;
  email: string;
  password: string;
  pseudo: string;
  avatarId: number;
  cryptorsDraftAccess?: Array<number>;
  isTesterAccount: boolean;
};

export type AccessTokenEntity = {
  /**
   * Signed JWT to use as a Bearer token on authenticated requests.
   */
  accessToken: string;
};

export type CreateMeDto = {
  title?: UserTitle | null;
  playMode?: PlayMode | null;
  acquisitionSource?: AcquisitionSource | null;
  email: string;
  password: string;
  pseudo: string;
  avatarId: number;
  isNewsletterAccepted: boolean;
  birthDay?: number | null;
  birthMonth?: number | null;
  birthYear?: number | null;
  country?: string | null;
  department?: string | null;
};

export type AvailabilityEntity = {
  /**
   * Whether the requested email / pseudo is free to use.
   */
  available: boolean;
};

export type ResendVerificationEmailDto = {
  email: string;
};

export type RequestPasswordResetDto = {
  email: string;
};

export type ResetPasswordDto = {
  email: string;
  password: string;
  code: string;
};

export type UserPasswordChangeDto = {
  oldPassword: string;
  newPassword: string;
};

export type RequestChangeEmailDto = {
  password: string;
  email: string;
};

export type RequestSetEmailDto = {
  email: string;
};

export type FillLoginDetailsDto = {
  email: string;
  password: string;
  isNewsletterAccepted: boolean;
};

export type LocationEntity = {
  id: number;
  latitude: number;
  longitude: number;
};

export type CityEntity = {
  id: number;
  name: string;
  qrfyIds: Array<number>;
  launchDate: string | null;
  location: LocationEntity;
};

export type CreateLocationDto = {
  latitude: number;
  longitude: number;
};

export type CreateCityDto = {
  name: string;
  qrfyIds?: Array<number>;
  launchDate?: string | null;
  location: CreateLocationDto;
};

export type LatLngEntity = {
  latitude: number;
  longitude: number;
};

export type AddressEntity = {
  id: number;
  locationAddress: string;
  city: CityEntity;
  location: LatLngEntity;
  locationRadius: number | null;
};

export type CryptorAddressLinkEntity = {
  address: AddressEntity;
};

export type CryptorToUserEntity = {
  createdAt: string;
  cryptorId: number;
  userId: number;
  score: number | null;
};

export type ArtefactEntity = {
  id: number;
  image: ImageEntity;
  reward: number;
  titlePopUpTranslation: Array<TranslationEntity>;
  textPopUpTranslation: Array<TranslationEntity>;
  isActive?: boolean;
  chatMessageId?: number | null;
};

export type CryptorQuizRefEntity = {
  id: number;
};

export const AdvertisementType = { STORY: "STORY", DISCUSSION: "DISCUSSION" } as const;

export type AdvertisementType = (typeof AdvertisementType)[keyof typeof AdvertisementType];

export type AdvertisementEntity = {
  id: number;
  title: string;
  url: string | null;
  image: ImageEntity;
};

export type CryptorAdvertisementLinkEntity = {
  type: AdvertisementType;
  order: number;
  advertisement: AdvertisementEntity;
};

export type CryptorEntity = {
  id: number;
  name: string;
  reward: number;
  primaryColor: string;
  secondaryColor: string;
  timeRestriction: boolean;
  timeRestrictionUrl: string | null;
  underMaintenance: boolean;
  birthDate: string | null;
  birthDateRaw: string | null;
  deathDate: string | null;
  placeOfBirth: string | null;
  shouldAnimateEyes: boolean;
  descriptionForAI: string | null;
  createdAt: string;
  archived: boolean;
  draft: boolean;
  mistralAIAgentIdFR: string | null;
  mistralAIAgentIdEN: string | null;
  mistralAIAgentIdES: string | null;
  mistralAIAgentIdDE: string | null;
  mistralAIAgentIdHU: string | null;
  mistralAIAgentIdIT: string | null;
  mistralAIAgentIdNL: string | null;
  mistralAIAgentIdPL: string | null;
  mistralAIAgentIdPT: string | null;
  image: ImageEntity;
  mapIcon: ImageEntity | null;
  obfuscatedImage: ImageEntity;
  characterImage: ImageEntity;
  avatar: AvatarEntity;
  addresses: Array<CryptorAddressLinkEntity>;
  cryptorToUser: Array<CryptorToUserEntity>;
  titleTranslation: Array<TranslationEntity>;
  linkWithThePlaceTranslation: Array<TranslationEntity>;
  quoteTranslation: Array<TranslationEntity>;
  descriptionTranslation: Array<TranslationEntity>;
  difficultyTranslation: Array<TranslationEntity>;
  artefactDescription: ArtefactEntity | null;
  artefactLinkWithThePlace: ArtefactEntity | null;
  artefactQuote: ArtefactEntity | null;
  quiz: CryptorQuizRefEntity | null;
  advertisements: Array<CryptorAdvertisementLinkEntity>;
};

export type CaptureByLinkDto = {
  token: string;
};

export type CryptorListCityEntity = {
  id: number;
  name: string;
};

export type CryptorListLocationEntity = {
  latitude: number;
  longitude: number;
};

export type CryptorsCollectionAddressEntity = {
  city: CryptorListCityEntity;
  location: CryptorListLocationEntity;
};

export type CryptorsCollectionAddressLinkEntity = {
  addressId: number;
  address: CryptorsCollectionAddressEntity;
};

export type CryptorArtefactStateEntity = {
  isActive: boolean;
};

export type CryptorsCollectionEntity = {
  id: number;
  primaryColor: string;
  image: ImageEntity;
  addresses: Array<CryptorsCollectionAddressLinkEntity>;
  artefactDescription: CryptorArtefactStateEntity | null;
  artefactLinkWithThePlace: CryptorArtefactStateEntity | null;
  artefactQuote: CryptorArtefactStateEntity | null;
  isCaptured: boolean;
  isAiAuthorized: boolean;
  isAiAvailable: boolean;
};

export type CryptorsMapAddressEntity = {
  location: CryptorListLocationEntity;
  city: CryptorListCityEntity;
};

export type CryptorsMapAddressLinkEntity = {
  addressId: number;
  address: CryptorsMapAddressEntity;
};

export type CryptorsMapEntity = {
  id: number;
  reward: number;
  primaryColor: string;
  image: ImageEntity;
  mapIcon: ImageEntity | null;
  obfuscatedImage: ImageEntity;
  addresses: Array<CryptorsMapAddressLinkEntity>;
  isCaptured: boolean;
  timeRestriction: boolean;
  underMaintenance: boolean;
  timeRestrictionUrl: string | null;
};

export type CryptorsListItemEntity = {
  id: number;
  avatar: AvatarEntity;
};

export type CryptorFilledUpEntity = {
  id: number;
  name: string;
  reward: number;
  primaryColor: string;
  secondaryColor: string;
  timeRestriction: boolean;
  timeRestrictionUrl: string | null;
  underMaintenance: boolean;
  birthDate: string | null;
  birthDateRaw: string | null;
  deathDate: string | null;
  placeOfBirth: string | null;
  shouldAnimateEyes: boolean;
  descriptionForAI: string | null;
  createdAt: string;
  archived: boolean;
  draft: boolean;
  mistralAIAgentIdFR: string | null;
  mistralAIAgentIdEN: string | null;
  mistralAIAgentIdES: string | null;
  mistralAIAgentIdDE: string | null;
  mistralAIAgentIdHU: string | null;
  mistralAIAgentIdIT: string | null;
  mistralAIAgentIdNL: string | null;
  mistralAIAgentIdPL: string | null;
  mistralAIAgentIdPT: string | null;
  image: ImageEntity;
  mapIcon: ImageEntity | null;
  obfuscatedImage: ImageEntity;
  characterImage: ImageEntity;
  avatar: AvatarEntity;
  addresses: Array<CryptorAddressLinkEntity>;
  cryptorToUser: Array<CryptorToUserEntity>;
  titleTranslation: Array<TranslationEntity>;
  linkWithThePlaceTranslation: Array<TranslationEntity>;
  quoteTranslation: Array<TranslationEntity>;
  descriptionTranslation: Array<TranslationEntity>;
  difficultyTranslation: Array<TranslationEntity>;
  artefactDescription: ArtefactEntity | null;
  artefactLinkWithThePlace: ArtefactEntity | null;
  artefactQuote: ArtefactEntity | null;
  quiz: CryptorQuizRefEntity | null;
  advertisements: Array<CryptorAdvertisementLinkEntity>;
  maxScore: number;
  myScore: number;
};

export type CreateAddressDto = {
  locationAddress: string;
  cityId: number;
  location: CreateLocationDto;
  locationRadius: number;
};

export type CreateArtefactDto = {
  image: CreateImageDto;
  titlePopUpTranslation: UpdateTranslationDto;
  textPopUpTranslation: UpdateTranslationDto;
  reward: number;
};

export type CreateCryptorDto = {
  name: string;
  birthDate?: string | null;
  birthDateRaw?: string | null;
  deathDate?: string | null;
  placeOfBirth?: string | null;
  characterImage: CreateImageDto;
  reward: number;
  primaryColor: string;
  secondaryColor: string;
  timeRestriction: boolean;
  timeRestrictionUrl?: string | null;
  underMaintenance: boolean;
  image: CreateImageDto;
  mapIcon?: CreateImageDto | null;
  obfuscatedImage: CreateImageDto;
  avatar: CreateAvatarDto;
  addresses: Array<CreateAddressDto>;
  translationTitle: UpdateTranslationDto;
  translationLinkWithThePlace: UpdateTranslationDto;
  translationDescription: UpdateTranslationDto;
  translationQuote: UpdateTranslationDto;
  translationDifficulty: UpdateTranslationDto;
  artefactDescription?: CreateArtefactDto | null;
  artefactLinkWithThePlace?: CreateArtefactDto | null;
  artefactQuote?: CreateArtefactDto | null;
  descriptionForAI?: string | null;
  mistralAIAgentIdFR?: string | null;
  mistralAIAgentIdEN?: string | null;
  mistralAIAgentIdES?: string | null;
  mistralAIAgentIdDE?: string | null;
  mistralAIAgentIdHU?: string | null;
  mistralAIAgentIdIT?: string | null;
  mistralAIAgentIdNL?: string | null;
  mistralAIAgentIdPL?: string | null;
  mistralAIAgentIdPT?: string | null;
  shouldAnimateEyes: boolean;
};

export type UpdateImageDto = {
  url?: string;
};

export type UpdateAvatarDto = {
  image: UpdateImageDto;
};

export type UpdateLocationDto = {
  latitude?: number;
  longitude?: number;
};

export type UpdateAddressDto = {
  id?: number;
  locationAddress?: string;
  cityId?: number;
  location: UpdateLocationDto;
  locationRadius?: number;
};

export type UpdateArtefactDto = {
  id?: number;
  image: CreateImageDto;
  titlePopUpTranslation: UpdateTranslationDto;
  textPopUpTranslation: UpdateTranslationDto;
  chatMessageId?: number;
  reward: number;
};

export type CryptorAdvertisementRefDto = {
  id: number;
};

export type UpdateCryptorDto = {
  name?: string;
  birthDate?: string | null;
  birthDateRaw?: string | null;
  deathDate?: string | null;
  placeOfBirth?: string | null;
  title?: string | null;
  quote?: string | null;
  characterImage?: UpdateImageDto;
  description?: string | null;
  reward?: number;
  primaryColor?: string;
  secondaryColor?: string;
  timeRestriction?: boolean;
  timeRestrictionUrl?: string | null;
  underMaintenance?: boolean;
  image?: UpdateImageDto;
  mapIcon?: UpdateImageDto | null;
  obfuscatedImage?: UpdateImageDto;
  avatar?: UpdateAvatarDto;
  addresses?: Array<UpdateAddressDto>;
  archived?: boolean;
  draft?: boolean;
  descriptionForAI?: string | null;
  translationTitle?: UpdateTranslationDto;
  translationLinkWithThePlace?: UpdateTranslationDto;
  translationDescription?: UpdateTranslationDto;
  translationQuote?: UpdateTranslationDto;
  translationDifficulty?: UpdateTranslationDto;
  artefactDescription?: UpdateArtefactDto | null;
  artefactLinkWithThePlace?: UpdateArtefactDto | null;
  artefactQuote?: UpdateArtefactDto | null;
  storyAdvertisements?: Array<CryptorAdvertisementRefDto>;
  discussionAdvertisements?: Array<CryptorAdvertisementRefDto>;
  mistralAIAgentIdFR?: string | null;
  mistralAIAgentIdEN?: string | null;
  mistralAIAgentIdES?: string | null;
  mistralAIAgentIdDE?: string | null;
  mistralAIAgentIdHU?: string | null;
  mistralAIAgentIdIT?: string | null;
  mistralAIAgentIdNL?: string | null;
  mistralAIAgentIdPL?: string | null;
  mistralAIAgentIdPT?: string | null;
  shouldAnimateEyes?: boolean;
};

export type QuizPropositionEntity = {
  id: string;
  isCorrect: boolean;
  textTranslation: Array<TranslationEntity>;
};

export type QuizQuestionAnswerDetailsEntity = {
  id: number;
  descriptionTranslation: Array<TranslationEntity>;
  image: ImageEntity | null;
};

export type QuizQuestionEntity = {
  id: string;
  reward: number;
  index: number | null;
  cryptorId: number | null;
  quizId: number | null;
  answerDetailsId: number | null;
  textTranslation: Array<TranslationEntity>;
  propositions: Array<QuizPropositionEntity>;
  answerDetails: QuizQuestionAnswerDetailsEntity | null;
};

export type QuizEntity = {
  id: number;
  reward: number;
  timerQuestion: number;
  cryptorId: number;
  questions: Array<QuizQuestionEntity>;
};

export type GenerateCaptureLinkDto = {
  expiresAt: string;
};

export type CaptureLinkEntity = {
  token: string;
  url: string;
  expiresAt: string;
};

export type FaqQuestionEntity = {
  id: number;
  question: string;
  answer: string;
  faqId: number;
  questionTranslation: Array<TranslationEntity>;
  answerTranslation: Array<TranslationEntity>;
};

export type FaqEntity = {
  id: number;
  faqQuestions: Array<FaqQuestionEntity>;
  nameTranslation: Array<TranslationEntity>;
};

export type FaqQuestionDto = {
  questionTranslation: {
    [key: string]: unknown;
  };
  answerTranslation: {
    [key: string]: unknown;
  };
};

export type CreateFaqDto = {
  faqQuestions: Array<FaqQuestionDto>;
  nameTranslation: {
    [key: string]: unknown;
  };
};

export type UpdateFaqDto = {
  nameTranslation: {
    [key: string]: unknown;
  };
  faqQuestions?: Array<FaqQuestionDto>;
};

export type AudioEntity = {
  id: number;
  url: string;
  createdAt: string;
};

export const VideoSource = { YOUTUBE: "YOUTUBE" } as const;

export type VideoSource = (typeof VideoSource)[keyof typeof VideoSource];

export type VideoEntity = {
  source: VideoSource;
  id: number;
  url: string;
  createdAt: string;
};

export const PropositionType = { CHOICE: "CHOICE", QUESTION: "QUESTION" } as const;

export type PropositionType = (typeof PropositionType)[keyof typeof PropositionType];

export type ChatPropositionEntity = {
  id: number;
  isCorrect: boolean;
  textTranslation: Array<TranslationEntity>;
  chatMessageId?: number | null;
};

export type ChatAnswerDetailsEntity = {
  id: number;
  descriptionTranslation: Array<TranslationEntity>;
};

export type ChatQuestionEntity = {
  type: PropositionType;
  id: number;
  reward: number | null;
  textTranslation: Array<TranslationEntity>;
  propositions: Array<ChatPropositionEntity>;
  goodAnswerDetails: ChatAnswerDetailsEntity | null;
  badAnswerDetails: ChatAnswerDetailsEntity | null;
};

export type ChatMessageEntity = {
  id: number;
  text: string | null;
  isEntryPoint: boolean;
  chatMessageChildrenId: number | null;
  shouldTriggerQuiz: boolean;
  textTranslation: Array<TranslationEntity>;
  image: ImageEntity | null;
  audio: AudioEntity | null;
  video: VideoEntity | null;
  question: ChatQuestionEntity | null;
};

export type UserChatPropositionEntity = {
  id: number;
  isCorrect: boolean;
  text: string;
};

export type UserChatMediaEntity = {
  id: number;
  url: string;
};

export type UserChatMessageEntity = {
  type?: PropositionType;
  id?: string;
  chatMessageUserId?: number;
  chatQuestionUserId?: number;
  chatPropositionUserId?: number;
  text?: string;
  propositions?: Array<UserChatPropositionEntity>;
  image?: UserChatMediaEntity;
  audio?: UserChatMediaEntity;
  video?: UserChatMediaEntity;
  isMe?: boolean;
  artefactId?: number;
  shouldTriggerQuiz?: boolean;
};

export type ChatAnswerQuestionDto = {
  answerId: number;
};

export type CreateAudioDto = {
  url: string;
};

export type CreateVideoDto = {
  url: string;
};

export type CreateChatPropositionDto = {
  textTranslation: UpdateTranslationDto;
  isCorrect?: boolean | null;
  chatMessageId?: number | null;
};

export type CreateChatAnswerDetailsDto = {
  descriptionTranslation: UpdateTranslationDto;
};

export type CreateChatQuestionDto = {
  type: PropositionType;
  textTranslation: UpdateTranslationDto;
  reward?: number | null;
  propositions: Array<CreateChatPropositionDto>;
  goodAnswerDetails?: CreateChatAnswerDetailsDto | null;
  badAnswerDetails?: CreateChatAnswerDetailsDto | null;
};

export type CreateChatMessageDto = {
  textTranslation?: UpdateTranslationDto;
  isEntryPoint: boolean;
  shouldTriggerQuiz: boolean;
  image?: CreateImageDto | null;
  audio?: CreateAudioDto | null;
  video?: CreateVideoDto | null;
  question?: CreateChatQuestionDto | null;
  chatMessageChildrenId?: number;
};

export type UpdateChatMessageDto = {
  textTranslation?: UpdateTranslationDto;
  isEntryPoint: boolean;
  shouldTriggerQuiz: boolean;
  image?: CreateImageDto | null;
  audio?: CreateAudioDto | null;
  video?: CreateVideoDto | null;
  question?: CreateChatQuestionDto | null;
  chatMessageChildrenId?: number;
};

export type LevelEntity = {
  level: number;
  pointsRequired: number;
  nameTranslation: Array<TranslationEntity>;
  image: ImageEntity;
};

export type CreateLevelDto = {
  level: number;
  pointsRequired: number;
  image: CreateImageDto;
  nameTranslation: UpdateTranslationDto;
};

export type UpdateLevelDto = {
  name: string;
  pointsRequired: number;
  image?: UpdateImageDto;
  nameTranslation?: UpdateTranslationDto;
};

export const ChatGptType = {
  USER: "USER",
  ASSISTANT: "ASSISTANT",
  SYSTEM: "SYSTEM",
} as const;

export type ChatGptType = (typeof ChatGptType)[keyof typeof ChatGptType];

export type ChatGptMessageEntity = {
  type: ChatGptType;
  id: number;
  createdAt: string;
  content: string;
  userId: number;
  cryptorId: number;
};

export type CollectQuestionDto = {
  content: string;
};

export type CreateAdvertisementViewDto = {
  type: AdvertisementType;
  advertisementId: number;
  cryptorId: number;
};

export type CreateAdvertisementDto = {
  title: string;
  url: string | null;
  image: CreateImageDto;
};

export type UpdateAdvertisementDto = {
  title: string;
  url: string | null;
  image: UpdateImageDto;
};

export type AnnouncementEntity = {
  id: number;
  enabled: boolean;
  revision: number;
  endDate: string | null;
  createdAt: string;
  updatedAt: string;
  titleTranslation: Array<TranslationEntity>;
  messageTranslation: Array<TranslationEntity>;
};

export type AnnouncementTranslationDto = {
  value: string;
};

export type CreateAnnouncementDto = {
  enabled?: boolean;
  endDate?: string | null;
  titleTranslation: AnnouncementTranslationDto;
  messageTranslation: AnnouncementTranslationDto;
};

export type UpdateAnnouncementDto = {
  enabled?: boolean;
  endDate?: string | null;
  titleTranslation?: AnnouncementTranslationDto;
  messageTranslation?: AnnouncementTranslationDto;
};

export const FeedbackRating = {
  /**
   * NEGATIVE
   */
  NEGATIVE: 0,
  /**
   * NEUTRAL
   */
  NEUTRAL: 1,
  /**
   * POSITIVE
   */
  POSITIVE: 2,
} as const;

export type FeedbackRating = (typeof FeedbackRating)[keyof typeof FeedbackRating];

export type SendFeedbackDto = {
  rate?: FeedbackRating;
  identifiant: string;
  content: string;
  collection?: string;
};

export type HintEntity = {
  id: string;
  index: number;
  descriptionTranslation: Array<TranslationEntity>;
  image: ImageEntity | null;
  rewardIfNotUsed: number;
  cryptorId: number;
};

export type CreateHintDto = {
  index: number;
  cryptorId: number;
  descriptionTranslation: UpdateTranslationDto;
  image: CreateImageDto | null;
  rewardIfNotUsed: number;
};

export type UpdateHintDto = {
  index: number;
  cryptorId: number;
  descriptionTranslation: UpdateTranslationDto;
  image?: UpdateImageDto | null;
  rewardIfNotUsed: number;
};

export type PropositionEntity = {
  id: string;
  isCorrect: boolean;
  textTranslation: Array<TranslationEntity>;
};

export type AnswerDetailEntity = {
  id: number;
  descriptionTranslation: Array<TranslationEntity>;
  image: ImageEntity | null;
};

export type QuestionEntity = {
  id: string;
  reward: number;
  index: number;
  cryptorId: number | null;
  quizId: number | null;
  answerDetailsId: number | null;
  textTranslation: Array<TranslationEntity>;
  propositions: Array<PropositionEntity>;
  answerDetails: AnswerDetailEntity | null;
};

export type QuestionAnswerDto = {
  propositionId: string;
};

export type CreatePropositionDto = {
  isCorrect: boolean;
  textTranslation: UpdateTranslationDto;
};

export type CreateAnswerDetailsDto = {
  descriptionTranslation: UpdateTranslationDto;
  image?: CreateImageDto | null;
};

export type CreateQuestionDto = {
  cryptorId?: number | null;
  quizId?: number | null;
  textTranslation: UpdateTranslationDto;
  reward?: number;
  index?: number | null;
  propositions: Array<CreatePropositionDto>;
  answerDetails?: CreateAnswerDetailsDto | null;
};

export type UpsertPropositionDto = {
  id?: string;
  isCorrect: boolean;
  textTranslation: UpdateTranslationDto;
};

export type UpdateAnswerDetailsDto = {
  id?: number;
  descriptionTranslation: UpdateTranslationDto;
  image?: UpdateImageDto | null;
};

export type UpdateQuestionDto = {
  cryptorId?: number | null;
  quizId?: number | null;
  textTranslation: UpdateTranslationDto;
  reward?: number;
  index?: number | null;
  propositions: Array<UpsertPropositionDto>;
  answerDetails?: UpdateAnswerDetailsDto | null;
};

export type QuizTakeGetResultQuestionEntity = {
  id: string;
};

export type QuizTakeGetResultCountEntity = {
  questions: number;
};

export type QuizTakeGetResultQuizEntity = {
  id: number;
  reward: number;
  timerQuestion: number;
  questions: Array<QuizTakeGetResultQuestionEntity>;
  _count: QuizTakeGetResultCountEntity;
};

export type QuizTakeGetResultPropositionQuestionEntity = {
  reward: number;
};

export type QuizTakeGetResultPropositionEntity = {
  isCorrect: boolean;
  question: QuizTakeGetResultPropositionQuestionEntity | null;
};

export type QuizTakeGetResultTakePropositionEntity = {
  id: string;
  createdAt: string;
  proposition: QuizTakeGetResultPropositionEntity;
};

export type QuizTakeGetResultEntity = {
  id: string;
  createdAt: string;
  quiz: QuizTakeGetResultQuizEntity;
  quizTakeProposition: Array<QuizTakeGetResultTakePropositionEntity>;
};

export type QuizAnswerPropositionEntity = {
  id: string;
  isCorrect: boolean;
};

export type QuizAnswerEntity = {
  id: string;
  proposition: QuizAnswerPropositionEntity;
};

export type UpdateQuizDto = {
  reward: number;
  timerQuestion: number;
};

export type CountEntity = {
  total: number;
};

export type PercentageCountEntity = {
  total: number;
  pct: number;
};

export type NullableCountEntity = {
  total: number | null;
};

export type DistributionEntryEntity = {
  count: number;
  pct: number;
};

export type GenderDistributionEntity = {
  agent: DistributionEntryEntity;
  agente: DistributionEntryEntity;
  indetermine: DistributionEntryEntity;
};

export type AgeBracketsEntity = {
  under18: DistributionEntryEntity;
  "18to25": DistributionEntryEntity;
  "26to40": DistributionEntryEntity;
  "41to60": DistributionEntryEntity;
  over60: DistributionEntryEntity;
};

export type ResidenceDistributionEntity = {
  france: DistributionEntryEntity;
  europe: DistributionEntryEntity;
  other: DistributionEntryEntity;
  unknown: DistributionEntryEntity;
};

export type PlayModeDistributionEntity = {
  solo: DistributionEntryEntity;
  friends: DistributionEntryEntity;
  family: DistributionEntryEntity;
};

export type DepartmentEntryEntity = {
  department: string;
  count: number;
  pct: number;
};

export type StoreRatingEntryEntity = {
  rating: number | null;
  ratingCount: number | null;
};

export type StoresEntity = {
  apple: StoreRatingEntryEntity;
  google: StoreRatingEntryEntity;
};

export type LanguageEntryEntity = {
  code: string;
  count: number;
  pct: number;
};

export type SnapshotKpisEntity = {
  players: CountEntity;
  registeredPlayers: PercentageCountEntity;
  activePlayersRatio: number | null;
  activePlayersCount: number | null;
  uninstallRatePct: number | null;
  collections: CountEntity;
  cryptors: CountEntity;
  captures: CountEntity;
  scans: NullableCountEntity;
  adViews: CountEntity;
  gender: GenderDistributionEntity;
  averageAge: number | null;
  under25Ratio: number | null;
  ageBrackets: AgeBracketsEntity;
  residence: ResidenceDistributionEntity;
  playMode: PlayModeDistributionEntity;
  departments: Array<DepartmentEntryEntity>;
  stores: StoresEntity;
  languages: Array<LanguageEntryEntity> | null;
  appLanguages: Array<LanguageEntryEntity>;
};

export type TopEntity = {
  id: number;
  name: string;
  captures: number;
};

export type NetworkKpisEntity = {
  players: CountEntity;
  collections: CountEntity;
  cryptors: CountEntity;
  scans: NullableCountEntity;
  playMode: PlayModeDistributionEntity;
  appLanguages: Array<LanguageEntryEntity>;
  averageAge: number | null;
  topCollections: Array<TopEntity>;
  topCryptors: Array<TopEntity>;
};

export type CollectionOptionEntity = {
  id: number;
  name: string;
  launchDate: string | null;
};

export type ClientCryptorSummaryEntity = {
  id: number;
  name: string;
  imageUrl: string;
};

export type ClientCryptorCollectionEntity = {
  cryptors: Array<ClientCryptorSummaryEntity>;
  id: number;
  name: string;
};

export type QrOptionEntity = {
  id: number;
  name: string;
};

export type ComparisonWindowEntity = {
  current: number | null;
  previous: number | null;
  variationPct: number | null;
};

export type IndicatorComparisonEntity = {
  scans: ComparisonWindowEntity;
  captures: ComparisonWindowEntity;
  acquiredPlayers: ComparisonWindowEntity;
};

export type ComparisonToDateEntity = {
  players: number;
  scans: number | null;
  captures: number;
};

export type TopGroupEntity = {
  qr: Array<TopEntity>;
  cryptors: Array<TopEntity>;
  collections: Array<TopEntity>;
};

export type ComparisonKpisEntity = {
  week: IndicatorComparisonEntity;
  month: IndicatorComparisonEntity;
  toDate: ComparisonToDateEntity;
  topWeekN1: TopGroupEntity;
  topWeek: TopGroupEntity;
  topMonthN1: TopGroupEntity;
  topMonth: TopGroupEntity;
};

export type PeriodRangeEntity = {
  from: string;
  to: string;
};

export type TimeSeriesPointEntity = {
  date: string;
  captures: number;
  scans?: number | null;
};

export type PeriodKpisEntity = {
  range: PeriodRangeEntity;
  cityIds: Array<number> | null;
  players: CountEntity;
  scans: NullableCountEntity;
  captures: CountEntity;
  emailConfirmed: CountEntity;
  topCryptors: Array<TopEntity>;
  topCollections: Array<TopEntity>;
  timeSeries: Array<TimeSeriesPointEntity>;
  averageCapturesPerCollection: number | null;
  heatmap: Array<Array<number>> | null;
};

export type AppControllerStoreData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/app-store";
};

export type AppControllerGetMinAppVersionData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/min-app-version";
};

export type AppControllerGetMinAppVersionResponses = {
  200: string;
};

export type AppControllerGetMinAppVersionResponse =
  AppControllerGetMinAppVersionResponses[keyof AppControllerGetMinAppVersionResponses];

export type TranslationControllerFindAllData = {
  body?: never;
  path?: never;
  query: {
    s: string;
  };
  url: "/translation";
};

export type TranslationControllerFindAllResponses = {
  200: Array<TranslationEntity>;
};

export type TranslationControllerFindAllResponse =
  TranslationControllerFindAllResponses[keyof TranslationControllerFindAllResponses];

export type TranslationControllerUpdateTranslationData = {
  body: UpdateTranslationDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/translation/{id}";
};

export type TranslationControllerUpdateTranslationResponses = {
  200: TranslationEntity;
};

export type TranslationControllerUpdateTranslationResponse =
  TranslationControllerUpdateTranslationResponses[keyof TranslationControllerUpdateTranslationResponses];

export type TranslationControllerGenerateMissingKeysData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/translation/generate-missing-keys";
};

export type TranslationControllerGenerateMissingKeysResponses = {
  200: GenerateMissingKeysEntity;
};

export type TranslationControllerGenerateMissingKeysResponse =
  TranslationControllerGenerateMissingKeysResponses[keyof TranslationControllerGenerateMissingKeysResponses];

export type TranslationAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/translation";
};

export type TranslationAdminControllerListResponses = {
  200: {
    data: Array<TranslationEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type TranslationAdminControllerListResponse =
  TranslationAdminControllerListResponses[keyof TranslationAdminControllerListResponses];

export type TranslationAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/translation";
};

export type TranslationAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type TranslationAdminControllerCreateOneResponse =
  TranslationAdminControllerCreateOneResponses[keyof TranslationAdminControllerCreateOneResponses];

export type TranslationAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/translation/{id}";
};

export type TranslationAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type TranslationAdminControllerDeleteOneResponse =
  TranslationAdminControllerDeleteOneResponses[keyof TranslationAdminControllerDeleteOneResponses];

export type TranslationAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/translation/{id}";
};

export type TranslationAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type TranslationAdminControllerGetOneResponse =
  TranslationAdminControllerGetOneResponses[keyof TranslationAdminControllerGetOneResponses];

export type TranslationAdminControllerUpdateOneData = {
  body: UpdateTranslationDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/translation/{id}";
};

export type TranslationAdminControllerUpdateOneResponses = {
  200: TranslationEntity;
};

export type TranslationAdminControllerUpdateOneResponse =
  TranslationAdminControllerUpdateOneResponses[keyof TranslationAdminControllerUpdateOneResponses];

export type TranslationAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/translation/bulk";
};

export type TranslationAdminControllerCreateManyResponses = {
  201: unknown;
};

export type S3ControllerGetSignedUrlData = {
  body?: never;
  path?: never;
  query: {
    filename: string;
    folder: string;
  };
  url: "/s3/put-signed-url";
};

export type S3ControllerGetSignedUrlResponses = {
  200: string;
};

export type S3ControllerGetSignedUrlResponse =
  S3ControllerGetSignedUrlResponses[keyof S3ControllerGetSignedUrlResponses];

export type AvatarsControllerFindAllAuthenticatedData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/avatars/owned";
};

export type AvatarsControllerFindAllAuthenticatedResponses = {
  200: Array<AvatarEntity>;
};

export type AvatarsControllerFindAllAuthenticatedResponse =
  AvatarsControllerFindAllAuthenticatedResponses[keyof AvatarsControllerFindAllAuthenticatedResponses];

export type AvatarsControllerFindAllUnAuthenticatedData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/avatars";
};

export type AvatarsControllerFindAllUnAuthenticatedResponses = {
  200: Array<AvatarEntity>;
};

export type AvatarsControllerFindAllUnAuthenticatedResponse =
  AvatarsControllerFindAllUnAuthenticatedResponses[keyof AvatarsControllerFindAllUnAuthenticatedResponses];

export type AvatarsControllerCreateData = {
  body: CreateAvatarDto;
  path?: never;
  query?: never;
  url: "/avatars";
};

export type AvatarsControllerCreateResponses = {
  201: AvatarEntity;
};

export type AvatarsControllerCreateResponse =
  AvatarsControllerCreateResponses[keyof AvatarsControllerCreateResponses];

export type AvatarsControllerFindMyAvatarData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/avatars/me";
};

export type AvatarsControllerFindMyAvatarResponses = {
  200: AvatarEntity;
};

export type AvatarsControllerFindMyAvatarResponse =
  AvatarsControllerFindMyAvatarResponses[keyof AvatarsControllerFindMyAvatarResponses];

export type AvatarsControllerUpdateMyAvatarData = {
  body: UpdateMyAvatarDto;
  path?: never;
  query?: never;
  url: "/avatars/me";
};

export type AvatarsControllerUpdateMyAvatarResponses = {
  200: unknown;
};

export type AvatarsControllerRemoveData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/avatars/{id}";
};

export type AvatarsControllerRemoveResponses = {
  204: void;
};

export type AvatarsControllerRemoveResponse =
  AvatarsControllerRemoveResponses[keyof AvatarsControllerRemoveResponses];

export type AvatarsControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/avatars/{id}";
};

export type AvatarsControllerFindOneResponses = {
  200: AvatarEntity;
};

export type AvatarsControllerFindOneResponse =
  AvatarsControllerFindOneResponses[keyof AvatarsControllerFindOneResponses];

export type AvatarsControllerUpdateData = {
  body: CreateAvatarDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/avatars/{id}";
};

export type AvatarsControllerUpdateResponses = {
  204: void;
};

export type AvatarsControllerUpdateResponse =
  AvatarsControllerUpdateResponses[keyof AvatarsControllerUpdateResponses];

export type AvatarsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/avatars";
};

export type AvatarsAdminControllerListResponses = {
  200: unknown;
};

export type AvatarsAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/avatars";
};

export type AvatarsAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type AvatarsAdminControllerCreateOneResponse =
  AvatarsAdminControllerCreateOneResponses[keyof AvatarsAdminControllerCreateOneResponses];

export type AvatarsAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/avatars/{id}";
};

export type AvatarsAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type AvatarsAdminControllerDeleteOneResponse =
  AvatarsAdminControllerDeleteOneResponses[keyof AvatarsAdminControllerDeleteOneResponses];

export type AvatarsAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/avatars/{id}";
};

export type AvatarsAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type AvatarsAdminControllerGetOneResponse =
  AvatarsAdminControllerGetOneResponses[keyof AvatarsAdminControllerGetOneResponses];

export type AvatarsAdminControllerUpdateOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/avatars/{id}";
};

export type AvatarsAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type AvatarsAdminControllerUpdateOneResponse =
  AvatarsAdminControllerUpdateOneResponses[keyof AvatarsAdminControllerUpdateOneResponses];

export type AvatarsAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/avatars/bulk";
};

export type AvatarsAdminControllerCreateManyResponses = {
  201: unknown;
};

export type UsersControllerLeaderboardData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/users/leaderboard";
};

export type UsersControllerLeaderboardResponses = {
  200: LeaderboardEntity;
};

export type UsersControllerLeaderboardResponse =
  UsersControllerLeaderboardResponses[keyof UsersControllerLeaderboardResponses];

export type UsersControllerDeleteAccountData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/users/me";
};

export type UsersControllerDeleteAccountResponses = {
  204: void;
};

export type UsersControllerDeleteAccountResponse =
  UsersControllerDeleteAccountResponses[keyof UsersControllerDeleteAccountResponses];

export type UsersControllerMeData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/users/me";
};

export type UsersControllerMeResponses = {
  200: UserResponseEntity;
};

export type UsersControllerMeResponse =
  UsersControllerMeResponses[keyof UsersControllerMeResponses];

export type UsersControllerUpdateMeData = {
  body: UpdateMeDto;
  path?: never;
  query?: never;
  url: "/users/me";
};

export type UsersControllerUpdateMeResponses = {
  204: void;
};

export type UsersControllerUpdateMeResponse =
  UsersControllerUpdateMeResponses[keyof UsersControllerUpdateMeResponses];

export type UsersControllerDeleteUserData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/users/{id}";
};

export type UsersControllerDeleteUserResponses = {
  204: void;
};

export type UsersControllerDeleteUserResponse =
  UsersControllerDeleteUserResponses[keyof UsersControllerDeleteUserResponses];

export type UsersControllerGetUserData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/users/{id}";
};

export type UsersControllerGetUserResponses = {
  200: UserResponseEntity;
};

export type UsersControllerGetUserResponse =
  UsersControllerGetUserResponses[keyof UsersControllerGetUserResponses];

export type UsersControllerUpdateUserData = {
  body: UpdateUserDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/users/{id}";
};

export type UsersControllerUpdateUserResponses = {
  204: void;
};

export type UsersControllerUpdateUserResponse =
  UsersControllerUpdateUserResponses[keyof UsersControllerUpdateUserResponses];

export type UsersControllerGetAllUsersData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/users";
};

export type UsersControllerGetAllUsersResponses = {
  200: Array<UserResponseEntity>;
};

export type UsersControllerGetAllUsersResponse =
  UsersControllerGetAllUsersResponses[keyof UsersControllerGetAllUsersResponses];

export type UsersControllerCreateUserData = {
  body: AdminCreateUserDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/users";
};

export type UsersControllerCreateUserResponses = {
  201: UserResponseEntity;
};

export type UsersControllerCreateUserResponse =
  UsersControllerCreateUserResponses[keyof UsersControllerCreateUserResponses];

export type UsersAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/users";
};

export type UsersAdminControllerListResponses = {
  200: {
    data: Array<UserResponseEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type UsersAdminControllerListResponse =
  UsersAdminControllerListResponses[keyof UsersAdminControllerListResponses];

export type UsersAdminControllerCreateOneData = {
  body: AdminCreateUserDto;
  path?: never;
  query?: never;
  url: "/admin/users";
};

export type UsersAdminControllerCreateOneResponses = {
  201: UserResponseEntity;
};

export type UsersAdminControllerCreateOneResponse =
  UsersAdminControllerCreateOneResponses[keyof UsersAdminControllerCreateOneResponses];

export type UsersAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/users/{id}";
};

export type UsersAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type UsersAdminControllerDeleteOneResponse =
  UsersAdminControllerDeleteOneResponses[keyof UsersAdminControllerDeleteOneResponses];

export type UsersAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/users/{id}";
};

export type UsersAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type UsersAdminControllerGetOneResponse =
  UsersAdminControllerGetOneResponses[keyof UsersAdminControllerGetOneResponses];

export type UsersAdminControllerUpdateOneData = {
  body: UpdateUserDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/users/{id}";
};

export type UsersAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type UsersAdminControllerUpdateOneResponse =
  UsersAdminControllerUpdateOneResponses[keyof UsersAdminControllerUpdateOneResponses];

export type UsersAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/users/bulk";
};

export type UsersAdminControllerCreateManyResponses = {
  201: unknown;
};

export type AuthControllerLoginData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/auth/login";
};

export type AuthControllerLoginResponses = {
  201: AccessTokenEntity;
};

export type AuthControllerLoginResponse =
  AuthControllerLoginResponses[keyof AuthControllerLoginResponses];

export type AuthControllerAnonymousLoginData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/auth/anonymous-login";
};

export type AuthControllerAnonymousLoginResponses = {
  201: AccessTokenEntity;
};

export type AuthControllerAnonymousLoginResponse =
  AuthControllerAnonymousLoginResponses[keyof AuthControllerAnonymousLoginResponses];

export type AuthControllerRegisterData = {
  body: CreateMeDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/auth/register";
};

export type AuthControllerRegisterResponses = {
  204: void;
};

export type AuthControllerRegisterResponse =
  AuthControllerRegisterResponses[keyof AuthControllerRegisterResponses];

export type AuthControllerMeData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/auth/me";
};

export type AuthControllerMeResponses = {
  200: UserResponseEntity;
};

export type AuthControllerMeResponse = AuthControllerMeResponses[keyof AuthControllerMeResponses];

export type AuthControllerVerifyEmailData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: "/auth/verify-email/{token}";
};

export type AuthControllerVerifyEmailResponses = {
  /**
   * HTML confirmation page (text/html).
   */
  200: unknown;
};

export type AuthControllerCheckEmailAvailabilityData = {
  body?: never;
  path?: never;
  query: {
    email: string;
  };
  url: "/auth/check-email-availability";
};

export type AuthControllerCheckEmailAvailabilityResponses = {
  200: AvailabilityEntity;
};

export type AuthControllerCheckEmailAvailabilityResponse =
  AuthControllerCheckEmailAvailabilityResponses[keyof AuthControllerCheckEmailAvailabilityResponses];

export type AuthControllerCheckPseudoAvailabilityData = {
  body?: never;
  path?: never;
  query: {
    pseudo: string;
  };
  url: "/auth/check-pseudo-availability";
};

export type AuthControllerCheckPseudoAvailabilityResponses = {
  200: AvailabilityEntity;
};

export type AuthControllerCheckPseudoAvailabilityResponse =
  AuthControllerCheckPseudoAvailabilityResponses[keyof AuthControllerCheckPseudoAvailabilityResponses];

export type AuthControllerResendVerificationEmailData = {
  body: ResendVerificationEmailDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/auth/resend-verification-email";
};

export type AuthControllerResendVerificationEmailResponses = {
  204: void;
};

export type AuthControllerResendVerificationEmailResponse =
  AuthControllerResendVerificationEmailResponses[keyof AuthControllerResendVerificationEmailResponses];

export type AuthControllerForgotPasswordData = {
  body: RequestPasswordResetDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/auth/request-password-reset";
};

export type AuthControllerForgotPasswordResponses = {
  204: void;
};

export type AuthControllerForgotPasswordResponse =
  AuthControllerForgotPasswordResponses[keyof AuthControllerForgotPasswordResponses];

export type AuthControllerResetPasswordCodeCheckData = {
  body?: never;
  path?: never;
  query: {
    email: string;
    code: string;
  };
  url: "/auth/reset-password-code-check";
};

export type AuthControllerResetPasswordCodeCheckResponses = {
  /**
   * Whether the reset code is valid and unexpired.
   */
  200: boolean;
};

export type AuthControllerResetPasswordCodeCheckResponse =
  AuthControllerResetPasswordCodeCheckResponses[keyof AuthControllerResetPasswordCodeCheckResponses];

export type AuthControllerResetPasswordData = {
  body: ResetPasswordDto;
  path?: never;
  query?: never;
  url: "/auth/reset-password";
};

export type AuthControllerResetPasswordResponses = {
  204: void;
};

export type AuthControllerResetPasswordResponse =
  AuthControllerResetPasswordResponses[keyof AuthControllerResetPasswordResponses];

export type AuthControllerChangePasswordData = {
  body: UserPasswordChangeDto;
  path?: never;
  query?: never;
  url: "/auth/change-password";
};

export type AuthControllerChangePasswordResponses = {
  204: void;
};

export type AuthControllerChangePasswordResponse =
  AuthControllerChangePasswordResponses[keyof AuthControllerChangePasswordResponses];

export type AuthControllerChangeEmailData = {
  body: RequestChangeEmailDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/auth/request-change-email";
};

export type AuthControllerChangeEmailResponses = {
  204: void;
};

export type AuthControllerChangeEmailResponse =
  AuthControllerChangeEmailResponses[keyof AuthControllerChangeEmailResponses];

export type AuthControllerRequestSetEmailData = {
  body: RequestSetEmailDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/auth/request-set-email";
};

export type AuthControllerRequestSetEmailResponses = {
  204: void;
};

export type AuthControllerRequestSetEmailResponse =
  AuthControllerRequestSetEmailResponses[keyof AuthControllerRequestSetEmailResponses];

export type AuthControllerVerifyChangeEmailData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: "/auth/verify-change-email/{token}";
};

export type AuthControllerVerifyChangeEmailResponses = {
  /**
   * Redirects to the `cryptors://` deep link.
   */
  204: void;
};

export type AuthControllerVerifyChangeEmailResponse =
  AuthControllerVerifyChangeEmailResponses[keyof AuthControllerVerifyChangeEmailResponses];

export type AuthControllerFillLoginDetailsData = {
  body: FillLoginDetailsDto;
  headers: {
    language: string;
  };
  path?: never;
  query?: never;
  url: "/auth/fill-login-details";
};

export type AuthControllerFillLoginDetailsResponses = {
  204: void;
};

export type AuthControllerFillLoginDetailsResponse =
  AuthControllerFillLoginDetailsResponses[keyof AuthControllerFillLoginDetailsResponses];

export type CitiesControllerFindAllData = {
  body?: never;
  path?: never;
  query?: {
    latitude?: number;
    longitude?: number;
    hasCryptors?: boolean;
  };
  url: "/cities";
};

export type CitiesControllerFindAllResponses = {
  200: Array<CityEntity>;
};

export type CitiesControllerFindAllResponse =
  CitiesControllerFindAllResponses[keyof CitiesControllerFindAllResponses];

export type CitiesControllerCreateData = {
  body: CreateCityDto;
  path?: never;
  query?: never;
  url: "/cities";
};

export type CitiesControllerCreateResponses = {
  201: CityEntity;
};

export type CitiesControllerCreateResponse =
  CitiesControllerCreateResponses[keyof CitiesControllerCreateResponses];

export type CitiesControllerRemoveData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/cities/{id}";
};

export type CitiesControllerRemoveResponses = {
  204: void;
};

export type CitiesControllerRemoveResponse =
  CitiesControllerRemoveResponses[keyof CitiesControllerRemoveResponses];

export type CitiesControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/cities/{id}";
};

export type CitiesControllerFindOneResponses = {
  200: CityEntity;
};

export type CitiesControllerFindOneResponse =
  CitiesControllerFindOneResponses[keyof CitiesControllerFindOneResponses];

export type CitiesControllerUpdateData = {
  body: CreateCityDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/cities/{id}";
};

export type CitiesControllerUpdateResponses = {
  200: CityEntity;
};

export type CitiesControllerUpdateResponse =
  CitiesControllerUpdateResponses[keyof CitiesControllerUpdateResponses];

export type CitiesAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/cities";
};

export type CitiesAdminControllerListResponses = {
  200: {
    data: Array<CityEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type CitiesAdminControllerListResponse =
  CitiesAdminControllerListResponses[keyof CitiesAdminControllerListResponses];

export type CitiesAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/cities";
};

export type CitiesAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type CitiesAdminControllerCreateOneResponse =
  CitiesAdminControllerCreateOneResponses[keyof CitiesAdminControllerCreateOneResponses];

export type CitiesAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/cities/{id}";
};

export type CitiesAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type CitiesAdminControllerDeleteOneResponse =
  CitiesAdminControllerDeleteOneResponses[keyof CitiesAdminControllerDeleteOneResponses];

export type CitiesAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/cities/{id}";
};

export type CitiesAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type CitiesAdminControllerGetOneResponse =
  CitiesAdminControllerGetOneResponses[keyof CitiesAdminControllerGetOneResponses];

export type CitiesAdminControllerUpdateOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/cities/{id}";
};

export type CitiesAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type CitiesAdminControllerUpdateOneResponse =
  CitiesAdminControllerUpdateOneResponses[keyof CitiesAdminControllerUpdateOneResponses];

export type CitiesAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/cities/bulk";
};

export type CitiesAdminControllerCreateManyResponses = {
  201: unknown;
};

export type CryptorsControllerFoundCryptorData = {
  body: {
    file: Blob | File;
  };
  path?: never;
  query: {
    latitude: number;
    longitude: number;
  };
  url: "/cryptors/scan";
};

export type CryptorsControllerFoundCryptorResponses = {
  201: CryptorEntity;
};

export type CryptorsControllerFoundCryptorResponse =
  CryptorsControllerFoundCryptorResponses[keyof CryptorsControllerFoundCryptorResponses];

export type CryptorsControllerCaptureRedirectData = {
  body?: never;
  path?: never;
  query: {
    token: string;
  };
  url: "/capture";
};

export type CryptorsControllerCaptureRedirectResponses = {
  /**
   * HTML landing page that hands off to the cryptors:// deep link.
   */
  200: unknown;
};

export type CryptorsControllerCaptureByLinkData = {
  body: CaptureByLinkDto;
  path?: never;
  query?: never;
  url: "/cryptors/capture-by-link";
};

export type CryptorsControllerCaptureByLinkResponses = {
  201: CryptorEntity;
};

export type CryptorsControllerCaptureByLinkResponse =
  CryptorsControllerCaptureByLinkResponses[keyof CryptorsControllerCaptureByLinkResponses];

export type CryptorsControllerFoundCryptorTutorialData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cryptors/scan-tutorial";
};

export type CryptorsControllerFoundCryptorTutorialResponses = {
  201: CryptorEntity;
};

export type CryptorsControllerFoundCryptorTutorialResponse =
  CryptorsControllerFoundCryptorTutorialResponses[keyof CryptorsControllerFoundCryptorTutorialResponses];

export type CryptorsControllerFindAllCollectionData = {
  body?: never;
  path?: never;
  query?: {
    completed?: boolean;
    archived?: boolean;
    limit?: number;
  };
  url: "/cryptors-collection";
};

export type CryptorsControllerFindAllCollectionResponses = {
  200: Array<CryptorsCollectionEntity>;
};

export type CryptorsControllerFindAllCollectionResponse =
  CryptorsControllerFindAllCollectionResponses[keyof CryptorsControllerFindAllCollectionResponses];

export type CryptorsControllerFindAllMapData = {
  body?: never;
  path?: never;
  query?: {
    completed?: boolean;
    archived?: boolean;
    limit?: number;
  };
  url: "/cryptors-map";
};

export type CryptorsControllerFindAllMapResponses = {
  200: Array<CryptorsMapEntity>;
};

export type CryptorsControllerFindAllMapResponse =
  CryptorsControllerFindAllMapResponses[keyof CryptorsControllerFindAllMapResponses];

export type CryptorsControllerFindAllData = {
  body?: never;
  path?: never;
  query?: {
    archived?: boolean;
  };
  url: "/cryptors";
};

export type CryptorsControllerFindAllResponses = {
  200: Array<CryptorsListItemEntity>;
};

export type CryptorsControllerFindAllResponse =
  CryptorsControllerFindAllResponses[keyof CryptorsControllerFindAllResponses];

export type CryptorsControllerCreateData = {
  body: CreateCryptorDto;
  path?: never;
  query?: never;
  url: "/cryptors";
};

export type CryptorsControllerCreateResponses = {
  201: CryptorEntity;
};

export type CryptorsControllerCreateResponse =
  CryptorsControllerCreateResponses[keyof CryptorsControllerCreateResponses];

export type CryptorsControllerGetQuizScoreData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/cryptors/{id}/is-ai-authorized";
};

export type CryptorsControllerGetQuizScoreResponses = {
  200: boolean;
};

export type CryptorsControllerGetQuizScoreResponse =
  CryptorsControllerGetQuizScoreResponses[keyof CryptorsControllerGetQuizScoreResponses];

export type CryptorsControllerRemoveData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/cryptors/{id}";
};

export type CryptorsControllerRemoveResponses = {
  204: void;
};

export type CryptorsControllerRemoveResponse =
  CryptorsControllerRemoveResponses[keyof CryptorsControllerRemoveResponses];

export type CryptorsControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/cryptors/{id}";
};

export type CryptorsControllerFindOneResponses = {
  200: CryptorFilledUpEntity;
};

export type CryptorsControllerFindOneResponse =
  CryptorsControllerFindOneResponses[keyof CryptorsControllerFindOneResponses];

export type CryptorsControllerUpdateData = {
  body: UpdateCryptorDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/cryptors/{id}";
};

export type CryptorsControllerUpdateResponses = {
  200: CryptorEntity;
};

export type CryptorsControllerUpdateResponse =
  CryptorsControllerUpdateResponses[keyof CryptorsControllerUpdateResponses];

export type CryptorsControllerGetQuizData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/cryptors/{id}/quiz";
};

export type CryptorsControllerGetQuizResponses = {
  200: QuizEntity;
};

export type CryptorsControllerGetQuizResponse =
  CryptorsControllerGetQuizResponses[keyof CryptorsControllerGetQuizResponses];

export type CryptorsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/cryptors";
};

export type CryptorsAdminControllerListResponses = {
  200: {
    data: Array<CryptorEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type CryptorsAdminControllerListResponse =
  CryptorsAdminControllerListResponses[keyof CryptorsAdminControllerListResponses];

export type CryptorsAdminControllerCreateOneData = {
  body: CreateCryptorDto;
  path?: never;
  query?: never;
  url: "/admin/cryptors";
};

export type CryptorsAdminControllerCreateOneResponses = {
  201: CryptorEntity;
};

export type CryptorsAdminControllerCreateOneResponse =
  CryptorsAdminControllerCreateOneResponses[keyof CryptorsAdminControllerCreateOneResponses];

export type CryptorsAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/cryptors/{id}";
};

export type CryptorsAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type CryptorsAdminControllerDeleteOneResponse =
  CryptorsAdminControllerDeleteOneResponses[keyof CryptorsAdminControllerDeleteOneResponses];

export type CryptorsAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/cryptors/{id}";
};

export type CryptorsAdminControllerGetOneResponses = {
  200: CryptorEntity;
};

export type CryptorsAdminControllerGetOneResponse =
  CryptorsAdminControllerGetOneResponses[keyof CryptorsAdminControllerGetOneResponses];

export type CryptorsAdminControllerUpdateOneData = {
  body: UpdateCryptorDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/cryptors/{id}";
};

export type CryptorsAdminControllerUpdateOneResponses = {
  200: CryptorEntity;
};

export type CryptorsAdminControllerUpdateOneResponse =
  CryptorsAdminControllerUpdateOneResponses[keyof CryptorsAdminControllerUpdateOneResponses];

export type CryptorsAdminControllerGenerateCaptureLinkData = {
  body: GenerateCaptureLinkDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/admin/cryptors/{id}/capture-link";
};

export type CryptorsAdminControllerGenerateCaptureLinkResponses = {
  201: CaptureLinkEntity;
};

export type CryptorsAdminControllerGenerateCaptureLinkResponse =
  CryptorsAdminControllerGenerateCaptureLinkResponses[keyof CryptorsAdminControllerGenerateCaptureLinkResponses];

export type CryptorsAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/cryptors/bulk";
};

export type CryptorsAdminControllerCreateManyResponses = {
  201: unknown;
};

export type FaqControllerFindAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/faq";
};

export type FaqControllerFindAllResponses = {
  200: Array<FaqEntity>;
};

export type FaqControllerFindAllResponse =
  FaqControllerFindAllResponses[keyof FaqControllerFindAllResponses];

export type FaqControllerCreateData = {
  body: CreateFaqDto;
  path?: never;
  query?: never;
  url: "/faq";
};

export type FaqControllerCreateResponses = {
  201: FaqEntity;
};

export type FaqControllerCreateResponse =
  FaqControllerCreateResponses[keyof FaqControllerCreateResponses];

export type FaqControllerRemoveData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/faq/{id}";
};

export type FaqControllerRemoveResponses = {
  200: FaqEntity;
};

export type FaqControllerRemoveResponse =
  FaqControllerRemoveResponses[keyof FaqControllerRemoveResponses];

export type FaqControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/faq/{id}";
};

export type FaqControllerFindOneResponses = {
  200: FaqEntity;
};

export type FaqControllerFindOneResponse =
  FaqControllerFindOneResponses[keyof FaqControllerFindOneResponses];

export type FaqControllerUpdateData = {
  body: UpdateFaqDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/faq/{id}";
};

export type FaqControllerUpdateResponses = {
  200: FaqEntity;
};

export type FaqControllerUpdateResponse =
  FaqControllerUpdateResponses[keyof FaqControllerUpdateResponses];

export type FaqAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/faq";
};

export type FaqAdminControllerListResponses = {
  200: {
    data: Array<FaqEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type FaqAdminControllerListResponse =
  FaqAdminControllerListResponses[keyof FaqAdminControllerListResponses];

export type FaqAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/faq";
};

export type FaqAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type FaqAdminControllerCreateOneResponse =
  FaqAdminControllerCreateOneResponses[keyof FaqAdminControllerCreateOneResponses];

export type FaqAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/faq/{id}";
};

export type FaqAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type FaqAdminControllerDeleteOneResponse =
  FaqAdminControllerDeleteOneResponses[keyof FaqAdminControllerDeleteOneResponses];

export type FaqAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/faq/{id}";
};

export type FaqAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type FaqAdminControllerGetOneResponse =
  FaqAdminControllerGetOneResponses[keyof FaqAdminControllerGetOneResponses];

export type FaqAdminControllerUpdateOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/faq/{id}";
};

export type FaqAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type FaqAdminControllerUpdateOneResponse =
  FaqAdminControllerUpdateOneResponses[keyof FaqAdminControllerUpdateOneResponses];

export type FaqAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/faq/bulk";
};

export type FaqAdminControllerCreateManyResponses = {
  201: unknown;
};

export type ChatControllerFindAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/chat";
};

export type ChatControllerFindAllResponses = {
  200: Array<ChatMessageEntity>;
};

export type ChatControllerFindAllResponse =
  ChatControllerFindAllResponses[keyof ChatControllerFindAllResponses];

export type ChatControllerGetCryptorChatData = {
  body?: never;
  headers: {
    language: string;
  };
  path: {
    cryptorId: number;
  };
  query?: never;
  url: "/chat/me/cryptor/{cryptorId}";
};

export type ChatControllerGetCryptorChatResponses = {
  200: Array<UserChatMessageEntity>;
};

export type ChatControllerGetCryptorChatResponse =
  ChatControllerGetCryptorChatResponses[keyof ChatControllerGetCryptorChatResponses];

export type ChatControllerAnswerQuestionData = {
  body: ChatAnswerQuestionDto;
  path: {
    chatQuestionUserId: number;
  };
  query?: never;
  url: "/chat/answer/{chatQuestionUserId}";
};

export type ChatControllerAnswerQuestionResponses = {
  204: void;
};

export type ChatControllerAnswerQuestionResponse =
  ChatControllerAnswerQuestionResponses[keyof ChatControllerAnswerQuestionResponses];

export type ChatControllerRegenerateMessageData = {
  body?: never;
  path: {
    cryptorId: number;
  };
  query?: never;
  url: "/chat/cryptor/{cryptorId}/chat/regenerate";
};

export type ChatControllerRegenerateMessageResponses = {
  204: void;
};

export type ChatControllerRegenerateMessageResponse =
  ChatControllerRegenerateMessageResponses[keyof ChatControllerRegenerateMessageResponses];

export type ChatControllerGetCryptorChatMessagesData = {
  body?: never;
  path: {
    cryptorId: number;
  };
  query?: never;
  url: "/chat/cryptors/{cryptorId}/chat-message";
};

export type ChatControllerGetCryptorChatMessagesResponses = {
  200: Array<ChatMessageEntity>;
};

export type ChatControllerGetCryptorChatMessagesResponse =
  ChatControllerGetCryptorChatMessagesResponses[keyof ChatControllerGetCryptorChatMessagesResponses];

export type ChatControllerCreateChatMessageData = {
  body: CreateChatMessageDto;
  path: {
    cryptorId: number;
  };
  query?: never;
  url: "/chat/cryptors/{cryptorId}/chat-message";
};

export type ChatControllerCreateChatMessageResponses = {
  201: ChatMessageEntity;
};

export type ChatControllerCreateChatMessageResponse =
  ChatControllerCreateChatMessageResponses[keyof ChatControllerCreateChatMessageResponses];

export type ChatControllerDeleteChatMessageData = {
  body?: never;
  path: {
    cryptorId: number;
    id: number;
  };
  query?: never;
  url: "/chat/cryptors/{cryptorId}/chat-message/{id}";
};

export type ChatControllerDeleteChatMessageResponses = {
  200: ChatMessageEntity;
};

export type ChatControllerDeleteChatMessageResponse =
  ChatControllerDeleteChatMessageResponses[keyof ChatControllerDeleteChatMessageResponses];

export type ChatControllerGetCryptorChatMessageData = {
  body?: never;
  path: {
    cryptorId: number;
    id: number;
  };
  query?: never;
  url: "/chat/cryptors/{cryptorId}/chat-message/{id}";
};

export type ChatControllerGetCryptorChatMessageResponses = {
  200: ChatMessageEntity;
};

export type ChatControllerGetCryptorChatMessageResponse =
  ChatControllerGetCryptorChatMessageResponses[keyof ChatControllerGetCryptorChatMessageResponses];

export type ChatControllerEditChatMessageData = {
  body: UpdateChatMessageDto;
  path: {
    cryptorId: number;
    id: number;
  };
  query?: never;
  url: "/chat/cryptors/{cryptorId}/chat-message/{id}";
};

export type ChatControllerEditChatMessageResponses = {
  200: ChatMessageEntity;
};

export type ChatControllerEditChatMessageResponse =
  ChatControllerEditChatMessageResponses[keyof ChatControllerEditChatMessageResponses];

export type ChatMessageAdminControllerListData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/chat-message";
};

export type ChatMessageAdminControllerListResponses = {
  200: unknown;
};

export type ChatMessageAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/chat-message";
};

export type ChatMessageAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type ChatMessageAdminControllerCreateOneResponse =
  ChatMessageAdminControllerCreateOneResponses[keyof ChatMessageAdminControllerCreateOneResponses];

export type ChatMessageAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/chat-message/{id}";
};

export type ChatMessageAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type ChatMessageAdminControllerDeleteOneResponse =
  ChatMessageAdminControllerDeleteOneResponses[keyof ChatMessageAdminControllerDeleteOneResponses];

export type ChatMessageAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/chat-message/{id}";
};

export type ChatMessageAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type ChatMessageAdminControllerGetOneResponse =
  ChatMessageAdminControllerGetOneResponses[keyof ChatMessageAdminControllerGetOneResponses];

export type ChatMessageAdminControllerUpdateOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/chat-message/{id}";
};

export type ChatMessageAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type ChatMessageAdminControllerUpdateOneResponse =
  ChatMessageAdminControllerUpdateOneResponses[keyof ChatMessageAdminControllerUpdateOneResponses];

export type ChatMessageAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/chat-message/bulk";
};

export type ChatMessageAdminControllerCreateManyResponses = {
  201: unknown;
};

export type LevelsControllerFindAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/levels";
};

export type LevelsControllerFindAllResponses = {
  200: Array<LevelEntity>;
};

export type LevelsControllerFindAllResponse =
  LevelsControllerFindAllResponses[keyof LevelsControllerFindAllResponses];

export type LevelsControllerCreateData = {
  body: CreateLevelDto;
  path?: never;
  query?: never;
  url: "/levels";
};

export type LevelsControllerCreateResponses = {
  201: LevelEntity;
};

export type LevelsControllerCreateResponse =
  LevelsControllerCreateResponses[keyof LevelsControllerCreateResponses];

export type LevelsControllerRemoveData = {
  body?: never;
  path: {
    level: number;
  };
  query?: never;
  url: "/levels/{level}";
};

export type LevelsControllerRemoveResponses = {
  204: void;
};

export type LevelsControllerRemoveResponse =
  LevelsControllerRemoveResponses[keyof LevelsControllerRemoveResponses];

export type LevelsControllerFindOneData = {
  body?: never;
  path: {
    level: number;
  };
  query?: never;
  url: "/levels/{level}";
};

export type LevelsControllerFindOneResponses = {
  200: LevelEntity;
};

export type LevelsControllerFindOneResponse =
  LevelsControllerFindOneResponses[keyof LevelsControllerFindOneResponses];

export type LevelsControllerUpdateData = {
  body: UpdateLevelDto;
  path: {
    level: number;
  };
  query?: never;
  url: "/levels/{level}";
};

export type LevelsControllerUpdateResponses = {
  200: LevelEntity;
};

export type LevelsControllerUpdateResponse =
  LevelsControllerUpdateResponses[keyof LevelsControllerUpdateResponses];

export type LevelsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/levels";
};

export type LevelsAdminControllerListResponses = {
  200: {
    data: Array<LevelEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type LevelsAdminControllerListResponse =
  LevelsAdminControllerListResponses[keyof LevelsAdminControllerListResponses];

export type LevelsAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/levels";
};

export type LevelsAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type LevelsAdminControllerCreateOneResponse =
  LevelsAdminControllerCreateOneResponses[keyof LevelsAdminControllerCreateOneResponses];

export type LevelsAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/levels/{id}";
};

export type LevelsAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type LevelsAdminControllerDeleteOneResponse =
  LevelsAdminControllerDeleteOneResponses[keyof LevelsAdminControllerDeleteOneResponses];

export type LevelsAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/levels/{id}";
};

export type LevelsAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type LevelsAdminControllerGetOneResponse =
  LevelsAdminControllerGetOneResponses[keyof LevelsAdminControllerGetOneResponses];

export type LevelsAdminControllerUpdateOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/levels/{id}";
};

export type LevelsAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type LevelsAdminControllerUpdateOneResponse =
  LevelsAdminControllerUpdateOneResponses[keyof LevelsAdminControllerUpdateOneResponses];

export type LevelsAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/levels/bulk";
};

export type LevelsAdminControllerCreateManyResponses = {
  201: unknown;
};

export type ChatgptControllerGetCryptorChatGptData = {
  body?: never;
  headers: {
    language: string;
  };
  path: {
    cryptorId: number;
  };
  query?: never;
  url: "/chatgpt/me/cryptor/{cryptorId}";
};

export type ChatgptControllerGetCryptorChatGptResponses = {
  200: Array<ChatGptMessageEntity>;
};

export type ChatgptControllerGetCryptorChatGptResponse =
  ChatgptControllerGetCryptorChatGptResponses[keyof ChatgptControllerGetCryptorChatGptResponses];

export type ChatgptControllerCollectQuestionData = {
  body: CollectQuestionDto;
  headers: {
    language: string;
  };
  path: {
    cryptorId: number;
  };
  query?: never;
  url: "/chatgpt/me/cryptor/{cryptorId}";
};

export type ChatgptControllerCollectQuestionResponses = {
  201: ChatGptMessageEntity;
};

export type ChatgptControllerCollectQuestionResponse =
  ChatgptControllerCollectQuestionResponses[keyof ChatgptControllerCollectQuestionResponses];

export type AdvertisementsControllerFindAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/advertisements";
};

export type AdvertisementsControllerFindAllResponses = {
  200: Array<AdvertisementEntity>;
};

export type AdvertisementsControllerFindAllResponse =
  AdvertisementsControllerFindAllResponses[keyof AdvertisementsControllerFindAllResponses];

export type AdvertisementsControllerCreateData = {
  body: CreateAdvertisementDto;
  path?: never;
  query?: never;
  url: "/advertisements";
};

export type AdvertisementsControllerCreateResponses = {
  201: AdvertisementEntity;
};

export type AdvertisementsControllerCreateResponse =
  AdvertisementsControllerCreateResponses[keyof AdvertisementsControllerCreateResponses];

export type AdvertisementsControllerRecordViewData = {
  body: CreateAdvertisementViewDto;
  path?: never;
  query?: never;
  url: "/advertisements/views";
};

export type AdvertisementsControllerRecordViewResponses = {
  201: unknown;
};

export type AdvertisementsControllerRemoveData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/advertisements/{id}";
};

export type AdvertisementsControllerRemoveResponses = {
  204: void;
};

export type AdvertisementsControllerRemoveResponse =
  AdvertisementsControllerRemoveResponses[keyof AdvertisementsControllerRemoveResponses];

export type AdvertisementsControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/advertisements/{id}";
};

export type AdvertisementsControllerFindOneResponses = {
  200: AdvertisementEntity;
};

export type AdvertisementsControllerFindOneResponse =
  AdvertisementsControllerFindOneResponses[keyof AdvertisementsControllerFindOneResponses];

export type AdvertisementsControllerUpdateData = {
  body: UpdateAdvertisementDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/advertisements/{id}";
};

export type AdvertisementsControllerUpdateResponses = {
  200: AdvertisementEntity;
};

export type AdvertisementsControllerUpdateResponse =
  AdvertisementsControllerUpdateResponses[keyof AdvertisementsControllerUpdateResponses];

export type AdvertisementsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/advertisements";
};

export type AdvertisementsAdminControllerListResponses = {
  200: {
    data: Array<AdvertisementEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type AdvertisementsAdminControllerListResponse =
  AdvertisementsAdminControllerListResponses[keyof AdvertisementsAdminControllerListResponses];

export type AdvertisementsAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/advertisements";
};

export type AdvertisementsAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type AdvertisementsAdminControllerCreateOneResponse =
  AdvertisementsAdminControllerCreateOneResponses[keyof AdvertisementsAdminControllerCreateOneResponses];

export type AdvertisementsAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/advertisements/{id}";
};

export type AdvertisementsAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type AdvertisementsAdminControllerDeleteOneResponse =
  AdvertisementsAdminControllerDeleteOneResponses[keyof AdvertisementsAdminControllerDeleteOneResponses];

export type AdvertisementsAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/advertisements/{id}";
};

export type AdvertisementsAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type AdvertisementsAdminControllerGetOneResponse =
  AdvertisementsAdminControllerGetOneResponses[keyof AdvertisementsAdminControllerGetOneResponses];

export type AdvertisementsAdminControllerUpdateOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/advertisements/{id}";
};

export type AdvertisementsAdminControllerUpdateOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type AdvertisementsAdminControllerUpdateOneResponse =
  AdvertisementsAdminControllerUpdateOneResponses[keyof AdvertisementsAdminControllerUpdateOneResponses];

export type AdvertisementsAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/advertisements/bulk";
};

export type AdvertisementsAdminControllerCreateManyResponses = {
  201: unknown;
};

export type AnnouncementsControllerFindActiveData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/announcements";
};

export type AnnouncementsControllerFindActiveResponses = {
  200: Array<AnnouncementEntity>;
};

export type AnnouncementsControllerFindActiveResponse =
  AnnouncementsControllerFindActiveResponses[keyof AnnouncementsControllerFindActiveResponses];

export type AnnouncementsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/announcements";
};

export type AnnouncementsAdminControllerListResponses = {
  200: {
    data: Array<AnnouncementEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type AnnouncementsAdminControllerListResponse =
  AnnouncementsAdminControllerListResponses[keyof AnnouncementsAdminControllerListResponses];

export type AnnouncementsAdminControllerCreateData = {
  body: CreateAnnouncementDto;
  path?: never;
  query?: never;
  url: "/admin/announcements";
};

export type AnnouncementsAdminControllerCreateResponses = {
  201: AnnouncementEntity;
};

export type AnnouncementsAdminControllerCreateResponse =
  AnnouncementsAdminControllerCreateResponses[keyof AnnouncementsAdminControllerCreateResponses];

export type AnnouncementsAdminControllerRemoveData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/admin/announcements/{id}";
};

export type AnnouncementsAdminControllerRemoveResponses = {
  200: AnnouncementEntity;
};

export type AnnouncementsAdminControllerRemoveResponse =
  AnnouncementsAdminControllerRemoveResponses[keyof AnnouncementsAdminControllerRemoveResponses];

export type AnnouncementsAdminControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/admin/announcements/{id}";
};

export type AnnouncementsAdminControllerFindOneResponses = {
  200: AnnouncementEntity;
};

export type AnnouncementsAdminControllerFindOneResponse =
  AnnouncementsAdminControllerFindOneResponses[keyof AnnouncementsAdminControllerFindOneResponses];

export type AnnouncementsAdminControllerUpdateData = {
  body: UpdateAnnouncementDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/admin/announcements/{id}";
};

export type AnnouncementsAdminControllerUpdateResponses = {
  200: AnnouncementEntity;
};

export type AnnouncementsAdminControllerUpdateResponse =
  AnnouncementsAdminControllerUpdateResponses[keyof AnnouncementsAdminControllerUpdateResponses];

export type FaqControllerSendFeedbackData = {
  body: SendFeedbackDto;
  path?: never;
  query?: never;
  url: "/feedback";
};

export type FaqControllerSendFeedbackResponses = {
  204: void;
};

export type FaqControllerSendFeedbackResponse =
  FaqControllerSendFeedbackResponses[keyof FaqControllerSendFeedbackResponses];

export type HintControllerRequestHintData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/hints/{id}/request";
};

export type HintControllerRequestHintResponses = {
  201: HintEntity;
};

export type HintControllerRequestHintResponse =
  HintControllerRequestHintResponses[keyof HintControllerRequestHintResponses];

export type HintControllerFindAllData = {
  body?: never;
  path?: never;
  query: {
    cryptorId: number;
  };
  url: "/hints";
};

export type HintControllerFindAllResponses = {
  200: Array<HintEntity>;
};

export type HintControllerFindAllResponse =
  HintControllerFindAllResponses[keyof HintControllerFindAllResponses];

export type HintControllerCreateData = {
  body: CreateHintDto;
  path?: never;
  query?: never;
  url: "/hints";
};

export type HintControllerCreateResponses = {
  204: void;
};

export type HintControllerCreateResponse =
  HintControllerCreateResponses[keyof HintControllerCreateResponses];

export type HintControllerRemoveData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/hints/{id}";
};

export type HintControllerRemoveResponses = {
  200: HintEntity;
};

export type HintControllerRemoveResponse =
  HintControllerRemoveResponses[keyof HintControllerRemoveResponses];

export type HintControllerFindOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/hints/{id}";
};

export type HintControllerFindOneResponses = {
  200: HintEntity;
};

export type HintControllerFindOneResponse =
  HintControllerFindOneResponses[keyof HintControllerFindOneResponses];

export type HintControllerUpdateData = {
  body: UpdateHintDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/hints/{id}";
};

export type HintControllerUpdateResponses = {
  204: void;
};

export type HintControllerUpdateResponse =
  HintControllerUpdateResponses[keyof HintControllerUpdateResponses];

export type HintsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/hints";
};

export type HintsAdminControllerListResponses = {
  200: {
    data: Array<HintEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type HintsAdminControllerListResponse =
  HintsAdminControllerListResponses[keyof HintsAdminControllerListResponses];

export type HintsAdminControllerCreateOneData = {
  body: CreateHintDto;
  path?: never;
  query?: never;
  url: "/admin/hints";
};

export type HintsAdminControllerCreateOneResponses = {
  204: void;
};

export type HintsAdminControllerCreateOneResponse =
  HintsAdminControllerCreateOneResponses[keyof HintsAdminControllerCreateOneResponses];

export type HintsAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/hints/{id}";
};

export type HintsAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type HintsAdminControllerDeleteOneResponse =
  HintsAdminControllerDeleteOneResponses[keyof HintsAdminControllerDeleteOneResponses];

export type HintsAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/hints/{id}";
};

export type HintsAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type HintsAdminControllerGetOneResponse =
  HintsAdminControllerGetOneResponses[keyof HintsAdminControllerGetOneResponses];

export type HintsAdminControllerUpdateOneData = {
  body: UpdateHintDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/hints/{id}";
};

export type HintsAdminControllerUpdateOneResponses = {
  204: void;
};

export type HintsAdminControllerUpdateOneResponse =
  HintsAdminControllerUpdateOneResponses[keyof HintsAdminControllerUpdateOneResponses];

export type HintsAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/hints/bulk";
};

export type HintsAdminControllerCreateManyResponses = {
  201: unknown;
};

export type QuestionsControllerFindAllData = {
  body?: never;
  path?: never;
  query: {
    cryptorId: number;
    answered?: boolean;
  };
  url: "/questions";
};

export type QuestionsControllerFindAllResponses = {
  200: Array<QuestionEntity>;
};

export type QuestionsControllerFindAllResponse =
  QuestionsControllerFindAllResponses[keyof QuestionsControllerFindAllResponses];

export type QuestionsControllerCreateData = {
  body: CreateQuestionDto;
  path?: never;
  query?: never;
  url: "/questions";
};

export type QuestionsControllerCreateResponses = {
  204: void;
};

export type QuestionsControllerCreateResponse =
  QuestionsControllerCreateResponses[keyof QuestionsControllerCreateResponses];

export type QuestionsControllerRemoveData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/questions/{id}";
};

export type QuestionsControllerRemoveResponses = {
  200: QuestionEntity;
};

export type QuestionsControllerRemoveResponse =
  QuestionsControllerRemoveResponses[keyof QuestionsControllerRemoveResponses];

export type QuestionsControllerFindOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/questions/{id}";
};

export type QuestionsControllerFindOneResponses = {
  200: QuestionEntity;
};

export type QuestionsControllerFindOneResponse =
  QuestionsControllerFindOneResponses[keyof QuestionsControllerFindOneResponses];

export type QuestionsControllerUpdateData = {
  body: UpdateQuestionDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/questions/{id}";
};

export type QuestionsControllerUpdateResponses = {
  204: void;
};

export type QuestionsControllerUpdateResponse =
  QuestionsControllerUpdateResponses[keyof QuestionsControllerUpdateResponses];

export type QuestionsControllerAnswerData = {
  body: QuestionAnswerDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/questions/{id}/answer";
};

export type QuestionsControllerAnswerResponses = {
  204: void;
};

export type QuestionsControllerAnswerResponse =
  QuestionsControllerAnswerResponses[keyof QuestionsControllerAnswerResponses];

export type QuestionsAdminControllerListData = {
  body?: never;
  path?: never;
  query?: {
    s?: string;
    search?: string;
    filter?: Array<string>;
    or?: Array<string>;
    sort?: Array<string>;
    join?: Array<string>;
    fields?: Array<string>;
    limit?: number;
    page?: number;
    offset?: number;
  };
  url: "/admin/questions";
};

export type QuestionsAdminControllerListResponses = {
  200: {
    data: Array<QuestionEntity>;
    total: number;
    count: number;
    page: number;
    pageCount: number;
  };
};

export type QuestionsAdminControllerListResponse =
  QuestionsAdminControllerListResponses[keyof QuestionsAdminControllerListResponses];

export type QuestionsAdminControllerCreateOneData = {
  body: CreateQuestionDto;
  path?: never;
  query?: never;
  url: "/admin/questions";
};

export type QuestionsAdminControllerCreateOneResponses = {
  204: void;
};

export type QuestionsAdminControllerCreateOneResponse =
  QuestionsAdminControllerCreateOneResponses[keyof QuestionsAdminControllerCreateOneResponses];

export type QuestionsAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/questions/{id}";
};

export type QuestionsAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type QuestionsAdminControllerDeleteOneResponse =
  QuestionsAdminControllerDeleteOneResponses[keyof QuestionsAdminControllerDeleteOneResponses];

export type QuestionsAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/questions/{id}";
};

export type QuestionsAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type QuestionsAdminControllerGetOneResponse =
  QuestionsAdminControllerGetOneResponses[keyof QuestionsAdminControllerGetOneResponses];

export type QuestionsAdminControllerUpdateOneData = {
  body: UpdateQuestionDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/questions/{id}";
};

export type QuestionsAdminControllerUpdateOneResponses = {
  204: void;
};

export type QuestionsAdminControllerUpdateOneResponse =
  QuestionsAdminControllerUpdateOneResponses[keyof QuestionsAdminControllerUpdateOneResponses];

export type QuestionsAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/questions/bulk";
};

export type QuestionsAdminControllerCreateManyResponses = {
  201: unknown;
};

export type QuizControllerCreateQuizTakeData = {
  body?: never;
  path: {
    quizId: number;
  };
  query?: never;
  url: "/quiz/{quizId}/take";
};

export type QuizControllerCreateQuizTakeResponses = {
  201: QuizTakeGetResultEntity;
};

export type QuizControllerCreateQuizTakeResponse =
  QuizControllerCreateQuizTakeResponses[keyof QuizControllerCreateQuizTakeResponses];

export type QuizControllerAnswerData = {
  body?: never;
  path: {
    quizTakeID: string;
    propositionId: string;
  };
  query?: never;
  url: "/quiz/take/{quizTakeID}/proposition/{propositionId}/answer";
};

export type QuizControllerAnswerResponses = {
  201: QuizAnswerEntity;
};

export type QuizControllerAnswerResponse =
  QuizControllerAnswerResponses[keyof QuizControllerAnswerResponses];

export type QuizControllerDeleteQuizData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/quiz/{id}";
};

export type QuizControllerDeleteQuizResponses = {
  200: QuizEntity;
};

export type QuizControllerDeleteQuizResponse =
  QuizControllerDeleteQuizResponses[keyof QuizControllerDeleteQuizResponses];

export type QuizControllerUpdateQuizData = {
  body: UpdateQuizDto;
  path: {
    id: number;
  };
  query?: never;
  url: "/quiz/{id}";
};

export type QuizControllerUpdateQuizResponses = {
  200: QuizEntity;
};

export type QuizControllerUpdateQuizResponse =
  QuizControllerUpdateQuizResponses[keyof QuizControllerUpdateQuizResponses];

export type QuizControllerCreateQuizData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/quiz/{id}";
};

export type QuizControllerCreateQuizResponses = {
  201: QuizEntity;
};

export type QuizControllerCreateQuizResponse =
  QuizControllerCreateQuizResponses[keyof QuizControllerCreateQuizResponses];

export type QuizControllerGetQuizTakeData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/quiz/quiz-take/{id}";
};

export type QuizControllerGetQuizTakeResponses = {
  200: QuizTakeGetResultEntity;
};

export type QuizControllerGetQuizTakeResponse =
  QuizControllerGetQuizTakeResponses[keyof QuizControllerGetQuizTakeResponses];

export type QuizAdminControllerDeleteOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/quiz/{id}";
};

export type QuizAdminControllerDeleteOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type QuizAdminControllerDeleteOneResponse =
  QuizAdminControllerDeleteOneResponses[keyof QuizAdminControllerDeleteOneResponses];

export type QuizAdminControllerGetOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/quiz/{id}";
};

export type QuizAdminControllerGetOneResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type QuizAdminControllerGetOneResponse =
  QuizAdminControllerGetOneResponses[keyof QuizAdminControllerGetOneResponses];

export type QuizAdminControllerUpdateOneData = {
  body: UpdateQuizDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/admin/quiz/{id}";
};

export type QuizAdminControllerUpdateOneResponses = {
  200: QuizEntity;
};

export type QuizAdminControllerUpdateOneResponse =
  QuizAdminControllerUpdateOneResponses[keyof QuizAdminControllerUpdateOneResponses];

export type QuizAdminControllerListData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/quiz";
};

export type QuizAdminControllerListResponses = {
  200: unknown;
};

export type QuizAdminControllerCreateOneData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/quiz";
};

export type QuizAdminControllerCreateOneResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type QuizAdminControllerCreateOneResponse =
  QuizAdminControllerCreateOneResponses[keyof QuizAdminControllerCreateOneResponses];

export type QuizAdminControllerCreateManyData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/quiz/bulk";
};

export type QuizAdminControllerCreateManyResponses = {
  201: unknown;
};

export type ArtefactsControllerFindOneData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: "/artefacts/{id}";
};

export type ArtefactsControllerFindOneResponses = {
  200: ArtefactEntity;
};

export type ArtefactsControllerFindOneResponse =
  ArtefactsControllerFindOneResponses[keyof ArtefactsControllerFindOneResponses];

export type PredictionControllerReindexData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/prediction/reindex";
};

export type PredictionControllerReindexResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type PredictionControllerReindexResponse =
  PredictionControllerReindexResponses[keyof PredictionControllerReindexResponses];

export type StatsAdminControllerSnapshotData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/stats/snapshot";
};

export type StatsAdminControllerSnapshotResponses = {
  200: SnapshotKpisEntity;
};

export type StatsAdminControllerSnapshotResponse =
  StatsAdminControllerSnapshotResponses[keyof StatsAdminControllerSnapshotResponses];

export type StatsAdminControllerNetworkData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/stats/network";
};

export type StatsAdminControllerNetworkResponses = {
  200: NetworkKpisEntity;
};

export type StatsAdminControllerNetworkResponse =
  StatsAdminControllerNetworkResponses[keyof StatsAdminControllerNetworkResponses];

export type StatsAdminControllerCollectionsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/stats/collections";
};

export type StatsAdminControllerCollectionsResponses = {
  200: Array<CollectionOptionEntity>;
};

export type StatsAdminControllerCollectionsResponse =
  StatsAdminControllerCollectionsResponses[keyof StatsAdminControllerCollectionsResponses];

export type StatsAdminControllerClientCryptorsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/stats/client-cryptors";
};

export type StatsAdminControllerClientCryptorsResponses = {
  200: Array<ClientCryptorCollectionEntity>;
};

export type StatsAdminControllerClientCryptorsResponse =
  StatsAdminControllerClientCryptorsResponses[keyof StatsAdminControllerClientCryptorsResponses];

export type StatsAdminControllerQrsData = {
  body?: never;
  path?: never;
  query?: {
    cityId?: string;
    cityIds?: string;
  };
  url: "/admin/stats/qrs";
};

export type StatsAdminControllerQrsResponses = {
  200: Array<QrOptionEntity>;
};

export type StatsAdminControllerQrsResponse =
  StatsAdminControllerQrsResponses[keyof StatsAdminControllerQrsResponses];

export type StatsAdminControllerComparisonData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/stats/comparison";
};

export type StatsAdminControllerComparisonResponses = {
  200: ComparisonKpisEntity;
};

export type StatsAdminControllerComparisonResponse =
  StatsAdminControllerComparisonResponses[keyof StatsAdminControllerComparisonResponses];

export type StatsAdminControllerPeriodData = {
  body?: never;
  path?: never;
  query?: {
    from?: string;
    to?: string;
    cityId?: string;
    cityIds?: string;
    qrfyIds?: string;
  };
  url: "/admin/stats/period";
};

export type StatsAdminControllerPeriodResponses = {
  200: PeriodKpisEntity;
};

export type StatsAdminControllerPeriodResponse =
  StatsAdminControllerPeriodResponses[keyof StatsAdminControllerPeriodResponses];
